import store from 'store';
import { playAudio, stopAudio, setPlaying } from 'actions/audioActions';
import { createSharedAudioHandle, coordinateSharedMediaElement } from './shared-audio-handle.mjs';

const dependencies = {
  getPlayer: () => window.audioPlayer,
  playSource: playAudio,
  stopSource: stopAudio,
  publishPlaying: (source, playing) => store.dispatch(setPlaying(source, playing)),
  subscribe: listener => store.subscribe(listener),
};

export const createNativeAudio = source => createSharedAudioHandle(source, dependencies);
export const coordinateNativeMedia = element => coordinateSharedMediaElement(element, dependencies);
